module.exports = __webpack_public_path__ + "img/pc_sigh.0fcc2125.png";